import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {HttpService} from '../../../services/http.service';
import {environment} from '../../../../environments/environment';
import {GridService} from '../../../services/grid.service';

@Component({
  selector: 'app-ai-push-to-learn-model',
  templateUrl: './ai-push-to-learn-model.component.html',
  styleUrls: ['./ai-push-to-learn-model.component.scss']
})
export class AiPushToLearnModelComponent implements OnInit {
  private params!: ICellRendererParams;
  public value: string = ''
  constructor(
    private httpService: HttpService,
    private gridService: GridService
  ) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  onStart() {
    // this.httpService.post(environment.API_PATH + `/ai/pushToLearn/${this.params.data.product_id}`, {}).subscribe(res => {
    //   this.gridService.aiLearGridEvent.next(true);
    // });
    this.httpService.post(environment.API_PATH + '/ai/startSelectedGptFineTuneModel', {ids: [this.params.data.product_id]}).subscribe(response => {
      this.gridService.aiFineTuneGptCompleteEvent.next(true);
    });
  }
  onClick() {
    console.log('params', this.params.data.product_id);
    this.httpService.post(environment.API_PATH + `/ai/pushToLearn/${this.params.data.product_id}`, {}).subscribe(res => {
      this.gridService.aiLearGridEvent.next(true);
    });
  }
}
